import React from 'react';
import { Modal } from '@fortress-technology-solutions/fortress-component-library/Molecules_Fortress';
import { Banner } from '@fortress-technology-solutions/fortress-component-library/Atoms';
import { Typography } from '@fortress-technology-solutions/fortress-component-library/Atoms';
import { TrashIcon } from '@fortress-technology-solutions/fortress-component-library/Icons';
import messages from './messages';

type Props = {
  open: boolean,
  onClose: Function,
  onConfirm: Function,
  intl: any,
  isDeleting?: boolean,
};

const DeleteRepaymentAgreementModal = ({
  open,
  onClose,
  onConfirm,
  intl,
  isDeleting = false,
}: Props) => {
  const actionsProps = [
    {
      children: intl.formatMessage(messages.cancel),
      onClick: onClose,
    },
    {
      children: intl.formatMessage(messages.confirm),
      onClick: onConfirm,
      submitButton: true,
      isSubmitting: isDeleting,
    },
  ];

  return (
    <Modal
      open={open}
      title={intl.formatMessage(messages.title)}
      onClose={onClose}
      icon={<TrashIcon />}
      actionsProps={actionsProps}
      ModalProps={{
        PaperProps: {
          sx: {
            maxWidth: 420,
          },
        },
      }}
    >
      <Typography
        variant="bodyMedium"
        color="text.secondary"
        marginBottom={1.5}
        display="block"
      >
        {intl.formatMessage(messages.confirmationText)}
      </Typography>
      <Banner
        status="warning"
        message={intl.formatMessage(messages.warningBanner)}
      />
    </Modal>
  );
};

export default DeleteRepaymentAgreementModal;
